import { Map, fromJS } from "immutable";
import { matchRoutes } from "react-router-dom";

import { router } from "../app/router";
import { selectCurrentPageName } from "../app/router";

let warnedUserOfUrlParams = false;

// dimensions
export const urlParams = () => {
	if (!warnedUserOfUrlParams) {
		console.warn("urlParams() is deprecated. Use 'useParams' from 'react-router-dom' instead.");
		warnedUserOfUrlParams = true;
	}

	const matches = matchRoutes(router.routes, window.location);
	const routeMatch = matches[matches.length - 1];

	return routeMatch ? fromJS(routeMatch.params) : Map();
};

export const getURLParam = (state, paramName) => urlParams().get(paramName, null);

export const getPageName = () => {
	const pageName = selectCurrentPageName();
	return pageName;
};

export const getQueryParams = (state) => state.navigation.getIn(["page", "query"], Map());
export const getQueryParam = (state, paramName) => getQueryParams(state).get(paramName, null);
export const selectQueryParamString = (state) => state.navigation.getIn(["page", "queryString"], "");

export const getCurrentPage = (state) => state.navigation.get("page", Map());
